import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBold,
  faCode,
  faItalic,
  faLink,
  faListOl,
  faListUl,
  faQuoteLeft,
  faUnderline,
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import "tippy.js/dist/tippy.css";
import {
  ToolbarElement,
  ToolbarMark,
  ToolbarList,
  ToolbarLink,
  useStoreEditorRef,
  useEventEditorId,
  getPlatePluginType,
  MARK_BOLD,
  MARK_ITALIC,
  MARK_UNDERLINE,
  MARK_CODE,
  ELEMENT_BLOCKQUOTE,
  ELEMENT_UL,
  ELEMENT_OL,
  ELEMENT_H1,
  ELEMENT_H2,
} from "@udecode/plate";

const RichTextEditorToolbar = () => {
  const editor = useStoreEditorRef(useEventEditorId("focus"));
  if (!editor) {
    return null;
  }

  return (
    <Toolbar>
      <ToolbarMark
        tooltip={{ content: "Bold" }}
        type={getPlatePluginType(editor, MARK_BOLD)}
        icon={<FontAwesomeIcon icon={faBold} />}
      />

      <ToolbarMark
        tooltip={{ content: "Italic" }}
        type={getPlatePluginType(editor, MARK_ITALIC)}
        icon={<FontAwesomeIcon icon={faItalic} />}
      />

      <ToolbarMark
        tooltip={{ content: "Underline" }}
        type={getPlatePluginType(editor, MARK_UNDERLINE)}
        icon={<FontAwesomeIcon icon={faUnderline} />}
      />

      <ToolbarMark
        tooltip={{ content: "Code" }}
        type={getPlatePluginType(editor, MARK_CODE)}
        icon={<FontAwesomeIcon icon={faCode} />}
      />

      <ToolbarElement
        tooltip={{ content: "Quote" }}
        type={getPlatePluginType(editor, ELEMENT_BLOCKQUOTE)}
        icon={<FontAwesomeIcon icon={faQuoteLeft} />}
      />

      <ToolbarElement
        tooltip={{ content: "Heading One" }}
        type={getPlatePluginType(editor, ELEMENT_H1)}
        icon={<span>H1</span>}
      />

      <ToolbarElement
        tooltip={{ content: "Heading Two" }}
        type={getPlatePluginType(editor, ELEMENT_H2)}
        icon={<span>H2</span>}
      />

      <ToolbarList
        tooltip={{ content: "Unordered List" }}
        type={getPlatePluginType(editor, ELEMENT_UL)}
        icon={<FontAwesomeIcon icon={faListUl} />}
      />

      <ToolbarList
        tooltip={{ content: "Ordered List" }}
        type={getPlatePluginType(editor, ELEMENT_OL)}
        icon={<FontAwesomeIcon icon={faListOl} />}
      />

      <ToolbarLink
        tooltip={{ content: "Link" }}
        icon={<FontAwesomeIcon icon={faLink} />}
      />
    </Toolbar>
  );
};

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.colors.muted};

  .slate-ToolbarButton {
    padding: 0 0.5rem;
    margin: 0 2px;
    font-size: 14px;
    width: auto;
    border-radius: 2px;
    font-weight: 700;
    font-family: ${({ theme }) => theme.font};
  }

  .slate-ToolbarButton:hover {
    background-color: ${({ theme }) => theme.colors.secondaryLight};
  }

  .slate-ToolbarButton-active {
    color: ${({ theme }) => theme.colors.secondary};
    background-color: ${({ theme }) => theme.colors.secondaryLight};
  }
`;

export default RichTextEditorToolbar;
